import type { Role } from "@/rvapi";
import rvapi from "@/rvapi";
import { compareDesc, compareAsc } from "@/utils";
import { defineStore } from "pinia";

export const useRolesStore = defineStore("roles", {
  state: () => ({
    roles: [] as Role[],
    loading: false,
  }),
  getters: {
    csRoles: (state) => {
      const csroles = state.roles.filter(
        (r) => r.role === "cs" || r.role === "csadm",
      );
      csroles.sort((a, b) => compareDesc(a.lastLogin, b.lastLogin));
      return csroles;
    },
    devRoles: (state) => {
      const roles = state.roles.filter(
        (r) => r.role !== "cs" && r.email !== "service_account",
      );
      roles.sort((a, b) => compareAsc(a.email, b.email));
      roles.sort((a, b) =>
        compareDesc(a.active.toString(), b.active.toString()),
      );
      return roles;
    },
  },
  actions: {
    async refresh() {
      if (!this.loading && this.roles.length === 0) {
        this.loading = true;
        this.roles = await rvapi.getAllRoles();
        this.loading = false;
      }
    },

    async updateRole(email: string, role: string, active: boolean) {
      const local = this.roles.filter((r) => r.email === email);
      if (local.length) {
        local[0].role = role;
        local[0].active = active;
      }
      return rvapi.setRole(email, role, active);
    },
  },
});
